/** Mirrors `Backoffice::User#manage_section?`. Do not use `manageCommittees` or `manageableSections`. */
export function canManageSectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  sectionLegacyId
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  sectionLegacyId?: string | null;
}): boolean {
  if (!sectionLegacyId) return false;
  if (isGlobalAdmin) return true;
  return assignedSectionLegacyIds.includes(sectionLegacyId);
}
